module.exports = __webpack_public_path__ + "static/media/Scale.dadd6c6c.png";